import React from 'react'

const CheckContainer = (props) => {
    const estilo = {
        principal: {
            marginTop: "3vh", textAlign: "left" 
        },
        label: {
            color: "#484848"
        }
    }
    return (
        <div style={estilo.principal}>
            <div style={estilo.label}>{props.texto}</div>
            {props.children}
        </div>
    )
}

export default CheckContainer